module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAIBAMAAAA7P9P/AAAAFVBMVEUAAAD///////////////////////9Iz20EAAAAB3RSTlMAEVVmd4iZWGeUdAAAAC9JREFUCB0FwbEJACAMALCI0NkrnL3CD9yLSP8/wcQAzQRXT8Ri4yFSJJQCUQkcfIHqBJbPn4/YAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/down.png
// module id = 251
// module chunks = 0